
import FaqItem from "./faqItem";
export default {
  name: "faqMain",
  components: {
    FaqItem,
  },
  data() {
    return {
      signup: [

        {
          question:
            "How do I get free report?",
          answer:
            "The <strong>FREE TRIAL</strong> runs a scan on selected services chosen by our tech team so you can see how it works in real time. To receive a full report requires the purchase of search credits for the online platforms or apps you want to scan.",
          open: false,
        },
        {
          question:
            "Why is FREE TRIAL blurred?",
          answer:
            "The <strong>FREE TRIAL</strong> is a sample to illustrate how the service works. To see complete results for more than the sampled platforms requires purchase of at least one search credit.",
          open: false,
        },
        {
          question:
            "Why didn't I receive a verification email",
          answer:
            "Your verification email may have gone to your <strong>SPAM</strong> or <strong>BULK</strong> folder because they are generated automatically. Depending on your internet service provider or if you are trying to access iFindCheaters.com from a LAN terminal there may be filters that block automated email. We recommend you only access the site from your personal device. If your verification email does not appear within 10-15 minutes, please let us know.",
          open: false,
        },
        {
          question:
            "Why is the SCAN/SEARCH taking so long?",
          answer:
            "The <strong>SCAN/SEARCH</strong> times may vary depending on what time you submit your request. The average is 2-5 minutes, but it may take longer based on the search you request, and if the sites being scanned are receiving heavy user traffic.",
          open: false,
        },
        {
          question:
            "How do I see the SCAN/SEARCH reports",
          answer:
            "As soon as you have entered your payment information the results will become visible. For your convenience, you can also download the report as a printable PDF document.",
          open: false,
        },
        {
          question:
            "Will the report emailed to me?",
          answer:
            "To protect confidentiality, we do not send reports via email. You will receive an email notification that the report is ready for viewing on the site.",
          open: false,
        },
        {
          question:
            "Do you provide partner's log information (username and password) for the sites or apps they have active accounts on?",
          answer:
            "Our service can confirm the existence of active accounts linked to your partner’s name and email address. We cannot access their passwords or materials they may have uploaded to those accounts. To do so would be an invasion of privacy and thus illegal.",
          open: false,
        },
      ],
      products: [

        {
          question:
            "DATING/ALTERNATIVE LIFESTYLE SITES OR SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS",
          answer:
            "<strong>FLEX</strong> – This option allows you to purchase as many search credits as you think you will need and use them individually to generate searches with any name or email address you choose.<br><br><strong>MONTHLY</strong> – This option runs a daily scan using one or more email addresses. You can request notification of results daily, or only when new activity is detected. Monthly plans have recurring billing. If you cancel the plan reports will continue to be generated until the end of that billing cycle but there will be no further charges.<br><br> <strong>ULTIMATE</strong> – This option gets you 15 search credits for each of our service areas providing you a comprehensive view of one person’s activity, or the flexibility to search for different people on different services. You decide when to scan each service and who your person of interest is. If they have multiple email addresses you can scan them all to be sure.",
          open: false,
        },
        {
          question:
            "LISTING LOCATOR",
          answer:
            "This service enables you to get information to verify identity, relationship status, physical addresses, telephone numbers and email. You can search for this information by entering their name, phone number, physical address or email. Whatever piece of information they have given you can be verified in one simple search.",
          open: false,
        },
        {
          question:
            "LIVE ADULT STREAMS OR XXX WEBSITES",
          answer:
            "<strong>XXX FLEX</strong> – Here also you have the option of purchasing individual or bundled search credits depending upon your needs. Learn if your partner is a consumer/subscriber to porn online. <br><br> <strong>XXX MONTHLY</strong> – These options run daily scans to monitor new activity and report notifications can be generated daily or whenever new activity is detected. Monthly plans have recurring billing. If you cancel the plan reports will continue to be generated until the end of that billing cycle but there will be no further charges.<br><br> <strong>XXX ULTIMATE</strong> – This package includes 15 search credits for use on each of our service areas. You get to choose when, and which service area to search on whomever you want. If your partner has multiple email addresses this option gives you a comprehensive look at their activity across the board.",
          open: false,
        },
        {
          question:
            "TINDER BLASTER",
          answer:
            "<strong>TINDER BLASTER BASIC</strong> – Enter the name, specific age, specific location you believe your partner may be using. A list of users matching those parameters. If you find your partner with an additional search credit you can request a PROFILE UPDATE that will provide you their <strong>Tinder ID</strong> and full profile details.<br><br> <strong>TINDER BLASTER EXTENDED</strong> – If the <strong>BASIC</strong> search is too narrow with an additional search credit you can provide an age range and broad location radius that sweeps a wider area of activity. Once you find your partner you can request a <strong>PROFILE UPDATE</strong> that will provide you their <strong>Tinder ID</strong> and full profile details.",
          open: false,
        },
      ],
      billing: [

        {
          question:
            "This is free?",
          answer:
            "There is no cost to register or to browse the site. There is a <strong>FREE TRIAL</strong> available for either selected <strong>DATING/ALTERNATIVE LIFESTYLE SITES</strong> or selected <strong>SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS</strong>. If you have requested a search using your partner’s name and email address, to access the complete results you will need to purchase one of the individual search credit options or a package plan. The technical maintenance and constant research and development required to keep our service current is a costly process, but we try to keep our prices as reasonable as possible. Every report is also downloadable as a PDF document.",
          open: false,
        },
        {
          question:
            "Can I cancel the FREE TRIAL at any time to avoid being billed?",
          answer:
            "No payment method is required to generate the <strong>FREE TRIAL</strong> scan. If you have purchased a Monthly option, you can request cancellation and will not be billed again at the end of the billing cycle.",
          open: false,
        },
        {
          question:
            "How will this charge appear on my bank or credit card statement?",
          answer:
            "When you use your credit or debit card the charge will appear as <strong>iFC Search Products</strong> on your monthly statement",
          open: false,
        },
        {
          question:
            "How can I pay so it won't on my bank or credit card statement?",
          answer:
            "If you do not want to provide a debit or credit card for fear of raising suspicion you may use a prepaid card or create a PayPal account, which many people use for shopping online.",
          open: false,
        },
        {
          question:
            "How can I pay with a prepaid card?",
          answer:
            "You enter the information for a prepaid card just as you would any other credit or debit card. There is technically no billing address with a prepaid card, but the fields will still need to be completed for the charge to be processed.",
          open: false,
        },
        {
          question:
            "How can I cancel my subscription?",
          answer:
            "When you have logged in, the menu to the left on your <strong>DASHBOARD</strong> page contains a cancellation option. If you have a monthly plan subscription, the account will remain active until the next billing cycle begins.",
          open: false,
        },
      ],
      search: [

        {
          question:
            "How do I find out if my partner is cheating?",
          answer:
            "iFindCheaters offers a variety of services to help you discover if you partner is active online. Once you know which sites or apps they are users of, and then you can do more research. You may want to start by verifying that the information they have given you is genuine by using our <strong>LISTING LOCATOR</strong> service.",
          open: false,
        },
        {
          question:
            "How do I learn if my partners is on DATING/ALTERNATIVE LIFESTYLE SITES?",
          answer:
            "When you enter their full name (first and last) and an email address our algorithms will search the databases of the bundle of sites/platforms or apps you have chosen. If they have an active profile connected to the information you have entered it will be discovered. Once you know what services they are using, you can follow up to see if they are still on the internet dating market.",
          open: false,
        },
        {
          question:
            "Can I check by entering a name only?",
          answer:
            "Most online sites/apps require users to enter a name and email address or mobile phone number. They may not be using their given name, maybe a nickname instead, having an email address increases the search power. Our <strong>LISTING LOCATOR</strong> can help you find other phone numbers or email addresses your partner might be using.",
          open: false,
        },
        {
          question:
            "Can I enter more than one email?",
          answer:
            "Once you have purchased search credits you can use them to search using any email you think might be involved. The Monthly options allow you to run searches on several emails at the same time.",
          open: false,
        },
        {
          question:
            "How does mobile monitoring work?",
          answer:
            "If you notice unfamiliar numbers on your partner’s phone you can use our <strong>LISTING LOCATOR</strong> service to discover whom that number belongs to. We also have active mobile phone monitoring services that will be launching soon.",
          open: false,
        },
        {
          question:
            "Other questions please submit this FORM",
          answer:
            "If you haven't found the answer to your question please let us know and submit this <strong>FORM</strong>. We value your input because it helps us offer better service.",
          open: false,
        },
      ],
    };
  },
  computed: {
    currentQuestion: {
      get() {
        switch (this.$store.state.faqModule.question) {
          case 1:
            return this.signup;
          case 2:
            return this.products;
          case 3:
            return this.billing;
          case 4:
            return this.search;
        }
      },
      set(){

      }
    }
  },
  methods: {
    toggleOpen: function (index) {
      this.currentQuestion = this.currentQuestion.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      });
    },
  },
};
